import { recordPath, recordRoute } from '@/shared/registry'

/** An organization's calendar, room calendar and instructor calendar, reached from Organization Details' side menu (CLS-24). */
export const organizationCalendarRoute = recordRoute('classes', 'calendar')
export const roomCalendarRoute = recordRoute('classes', 'room-calendar')
export const instructorCalendarRoute = recordRoute('classes', 'instructor-calendar')

export function organizationCalendarPath(organizationId: string): string {
  return recordPath('classes', 'calendar', organizationId)
}

export function roomCalendarPath(organizationId: string): string {
  return recordPath('classes', 'room-calendar', organizationId)
}

export function instructorCalendarPath(organizationId: string): string {
  return recordPath('classes', 'instructor-calendar', organizationId)
}

/** Which classes the organization calendar shows: those it owns, or those open to it too. */
export type CalendarAvailability = 'owned' | 'available'

/** The API's three calendars of an organization, from `from` to `to` (`YYYY-MM-DD`, at most 42 days). */
export function organizationCalendarApi(
  organizationId: string,
  range: { readonly from: string; readonly to: string },
  includeChildren: boolean,
  availability: CalendarAvailability,
): string {
  return calendarApi(organizationId, 'calendar', { ...range, includeChildren: String(includeChildren), availability })
}

/** With `includeExternal` left `null`, the organization's setting decides. */
export function roomCalendarApi(organizationId: string, range: { readonly from: string; readonly to: string }, includeExternal: boolean | null): string {
  return calendarApi(organizationId, 'room-calendar', includeExternal === null ? { ...range } : { ...range, includeExternal: String(includeExternal) })
}

export function instructorCalendarApi(organizationId: string, range: { readonly from: string; readonly to: string }): string {
  return calendarApi(organizationId, 'instructor-calendar', { ...range })
}

function calendarApi(organizationId: string, calendar: string, query: Record<string, string>): string {
  return `/classes/v1/organizations/${encodeURIComponent(organizationId)}/${calendar}?${new URLSearchParams(query).toString()}`
}
